import { gql } from '@apollo/client'

export const PRODUCT_IMAGE_FRAGMENT = gql`
  fragment ProductImage on ProductImage {
    id
    url
    created
    modified
  }
`
